import React, {useEffect, useState} from 'react';
import {concatenate} from "../../../services/string";

type Props = {
    hours: number[]
    onChange: (hours: number[]) => any
    join?: string
    disabled?: boolean
}

const paddedHour = (hour: number): string => {
    return hour.toString().padStart(2, '0') + ':00'
}

const currentHour = (): number => {
    return (new Date()).getHours()
}

function ByHourInput({hours, onChange, join, disabled}: Props) {
    const [start, setStart] = useState<number>(hours[0] ?? currentHour());
    const [end, setEnd] = useState<number>(hours[hours.length-1] ?? currentHour());

    useEffect(() => {
        const newHours: number[] = []

        const endNumber = (start <= end)? end : (end + 24)
        const expectedHourCount = (endNumber - start)

        for(let i = 0; i <= expectedHourCount; i++) {
            newHours.push((start + i) % 24)
        }

        newHours.sort((a, b) => a-b)

        const hoursHaveChanged = newHours.length !== hours.length
            || newHours.some((value, index) => value !== hours[index])

        if(hoursHaveChanged) onChange(newHours)

    }, [start, end, hours, onChange])

    return (
        <>
            <input
                type="time"
                id="input-byhour-start"
                name="byhour-start"
                step={3600}
                value={paddedHour(start)}
                onChange={event => setStart(parseInt(event.currentTarget.value))}
                className={concatenate(
                  "block rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-brand focus:outline-none focus:ring-brand sm:text-sm",
                  disabled ? 'text-gray-500 cursor-not-allowed' : '',
                )}
                disabled={disabled}
            />

            <span className="text-sm">{join ?? 'and'}</span>

            <input
                type="time"
                id="input-byhour-end"
                name="byhour-end"
                step={3600}
                value={paddedHour(end)}
                onChange={event => setEnd(parseInt(event.currentTarget.value))}
                className={concatenate(
                  "block rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-brand focus:outline-none focus:ring-brand sm:text-sm",
                  disabled ? 'text-gray-500 cursor-not-allowed' : '',
                )}
                disabled={disabled}
            />

        </>
    );
}

export default ByHourInput;